import { render, staticRenderFns } from "./CdImageSliderItem.vue?vue&type=template&id=573de2cc&scoped=true"
import script from "./CdImageSliderItem.vue?vue&type=script&lang=js"
export * from "./CdImageSliderItem.vue?vue&type=script&lang=js"
import style0 from "./CdImageSliderItem.vue?vue&type=style&index=0&id=573de2cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573de2cc",
  null
  
)

export default component.exports